exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.register-tabs-container{\n  min-height:517px\n}\n.register-tabs-container .con-tab{\n  padding-bottom:23px\n}", ""]);

// exports
